import * as angular from 'angular';

import { ComponentDefinition, IFrequency } from '../../../../models';
import { AllowedPeriods } from '../allowedPeriods';
import { IIntervalService } from '../../../../services';

interface ButtonDefinition {
    label: string;
    period: AllowedPeriods;
    tooltip?: string;
}

class AuditDashboardPickerController implements angular.IComponentController {
    buttons: ButtonDefinition[];
    selectedPeriod: AllowedPeriods;
    frequency: IFrequency;

    static $inject = ['intervalService'];

    constructor(private _intervalService: IIntervalService) {
    }

    $onInit() {
        this.buttons = [
            {
                label: 'd',
                period: 'd',
                tooltip: 'Day'
            },
            {
                label: 'w',
                period: 'w',
                tooltip: 'Week'
            }, {
                label: 'M',
                period: 'M',
                tooltip: 'Month'
            }
        ];
        this.select(this.buttons[0]);
    }

    select(button: ButtonDefinition) {
        this.selectedPeriod = button.period;
        this.frequency = {
            interval: 1,
            intervalTimeUnit: this._intervalService.getTimeUnit(this.selectedPeriod)
        };
    }
}

export const wtAuditDashboardPicker: ComponentDefinition = {
    componentId: 'wtAuditDashboardPicker',
    controller: AuditDashboardPickerController,
    template: require('./auditDashboardPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedPeriod: '=?',
        frequency: '=?'
    }
};
